import React, {useEffect, useState} from 'react';
import Share from "./Share.jsx";
import Shop from "./Shop.jsx";
import PieceList from "./PieceList.jsx";

export default function Menu({items, collections, selected, updateHandler}) {
	const [menuOpened, setMenuOpened] = useState(false);
	let chargerPlates = {};
	let dinnerPlates = {};
	let saladPlates = {};
	let tableCloths = {};

	if (items) {
		Object.entries(items).forEach(([id, item]) => {
			if (item.type === 'charger') {
				chargerPlates[id] = item;
			}
			if (item.type === 'dinner') {
				dinnerPlates[id] = item;
			}
			if (item.type === 'salad') {
				saladPlates[id] = item;
			}
			if (item.type === 'table') {
				tableCloths[id] = item;
			}
		});
	}

	const isMenuOpen = function(id) {
		return menuOpened === id;
	}

	return (
		<div id="menu-wrapper">
			<div id="main-menu" className="menu">
				{Object.entries(topMenuLabels).map(([key, val], index) =>
					<MenuSection key={index} id={key} label={val} />
				)}
			</div>
			<div id="secondary-menu" className="menu">
				{Object.entries(bottomMenuLabels).map(([key, val], index) =>
					<MenuSection key={index} id={key} label={val} />
				)}
			</div>
			{Object.entries(topMenuLabels).map(([key, val], index) =>
				<PieceSelector key={index} id={key} />
			)}
			<PieceSelector id="table" label={bottomMenuLabels.table} />
			<div id="share-menu" className={'section-collapse ' + (isMenuOpen('share') ? ' open' : '')}>
				<Share selected={selected} />
			</div>
			<div id="shop-menu" className={'section-collapse ' + (isMenuOpen('shop') ? ' open' : '')}>
				<Shop selected={selected} open={isMenuOpen('shop')} />
			</div>
		</div>
	);

	function MenuSection({id, label}) {
		return (
			<div className={'menu-section' + (isMenuOpen(id) ? ' open' : '')} >
				<div className={'submenu-toggle' + (isMenuOpen(id) ? ' open' : '')} role="button" aria-controls={id + "-menu"}
					aria-expanded={isMenuOpen(id)} onClick={(e) => {
						e.preventDefault();
						setMenuOpened((!isMenuOpen(id) || id === 'random') ? id : '');
						if (id === 'random') {
							randomize();
						}
						window.dataLayer.push({
							"event": "mix_and_match",
							"event_category": "menu click",
							"event_label": id
						});
					}}>
					<div id={id + '-icon'} className="menu-icon">
						<div></div>
					</div>
					{label}
				</div>
			</div>
		)
	}

	function PieceSelector({id}) {
		let pieces;
		switch (id) {
			case 'charger':
				pieces = chargerPlates;
				break;
			case 'dinner':
				pieces = dinnerPlates;
				break;
			case 'salad':
				pieces = saladPlates;
				break;
			case 'collection':
				pieces = collections;
				break;
			case 'table':
				pieces = tableCloths;
				break;
			default:
				break;
		}

		return (
			<div id={id + '-menu'} className={'section-collapse ' + (isMenuOpen(id) ? ' open' : '')}>
					<PieceList id={id} pieces={pieces} updateHandler={updateHandler} selected={selected}/>
			</div>
		)
	}

	function randomize() {
		let pieces = {};
		[chargerPlates, dinnerPlates, saladPlates].forEach(list => {
			const randIndex = Math.floor(Math.random() * Object.keys(list).length);
			const id = Object.keys(list)[randIndex];
			const piece = list[id];
			pieces[piece.type] = id;
		});
		updateHandler('random', pieces);
	}
}

const topMenuLabels = {
	charger: 'Chargers',
	dinner: 'Dinner Plates',
	salad: 'Salad Plates',
	collection: 'Curated Sets'
}

const bottomMenuLabels = {
	table: 'Backgrounds',
	random: 'Randomize',
	share: 'Share',
	shop: 'Shop'
}